// extracted by css-extract-rspack-plugin
export default {"root":"root-eZnlax","rootmedium":"rootmedium-OO8ij_","icon":"icon-yo_Rbh","iconmedium":"iconmedium-H0P6s5"};